// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-portal-jsx": () => import("./../../../src/pages/portal.jsx" /* webpackChunkName: "component---src-pages-portal-jsx" */),
  "component---src-pages-shippingoffer-js": () => import("./../../../src/pages/shippingoffer.js" /* webpackChunkName: "component---src-pages-shippingoffer-js" */)
}

